import { Component, OnInit, ViewChild } from '@angular/core';
import { RolOperacionService } from 'src/app/services/rol-operacion.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { CabeceraComponent } from './cabecera/cabecera.component';
import { DetallesComponent } from './detalles/detalles.component';

@Component({
  selector: 'app-reverso-pagos',
  templateUrl: './reverso-pagos.component.html',
  styleUrls: ['./reverso-pagos.component.scss'],
  providers: [SecurityService],
})
export class ReversoPagosComponent implements OnInit {

  // Modales
  @ViewChild(CabeceraComponent, { static: true }) cabeceraComponent: CabeceraComponent
  @ViewChild(DetallesComponent, { static: true }) detallesComponent: DetallesComponent
  
  canAddReversoPago: boolean = false

  // Data &  Tmp
  // private rutEmpresa: number;
  // private sucursalEmpresa: number;
  private rutUsuario: number;

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private rolOperacion: RolOperacionService,
    private clog: ConsoleService,

  ) {
    this.log = this.clog.log('REVERSO-PAGOS')
  }

  ngOnInit() {
    // this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    // this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario())
    this.canOperacionRol();
  }

  onSearch(values) {
    this.detallesComponent.loadData(values)
  }

  onSearchAll() {
    this.detallesComponent.loadAllData()
  }

  private canOperacionRol() {
    const inputPermiso = {
      rut_usu: this.rutUsuario,
      cod_operacion: 23, // Crear reverso pago
      codgo_modulo: 66, // REVERSO PAGO
    }
 
    this.rolOperacion.operacionPermitida(inputPermiso, (response: boolean) => {
      this.canAddReversoPago = response
      this.log('Permiso crear reverso pago:', this.canAddReversoPago)
    })
  }
}
